import type { VenderTranslationEntity } from './VenderTrasnlationEntity'

export class CreateUpdateVenderEntity {
  translations?: Array<VenderTranslationEntity>
  imageData?: { bytes: string; fileName: string }
  imageUrl?: string
}
